import script from "./RecompareDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecompareDialog.vue?vue&type=script&setup=true&lang=ts"

import "./RecompareDialog.vue?vue&type=style&index=0&id=c8e6a6b0&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8e6a6b0"]])

export default __exports__